// extracted by mini-css-extract-plugin
export default {"product_view":"ProductGrid_product_view__ZYnoZ"};